import React from 'react';
import { useTranslation } from 'react-i18next';

/** A plain bar: how far the household is from the next reward. No countdown,
 *  no urgency — just the distance, in words anyone can read. */
export const RewardProgress = ({ reward, sample = true, testId = 'play-reward-progress' }) => {
    const { t } = useTranslation();
    if (!reward) return null;
    const pct = Math.max(0, Math.min(100, Math.round((reward.progress || 0) * 100)));
    return (
        <div className="w-full max-w-sm" data-testid={testId}>
            <div className="mb-1 flex items-baseline justify-between gap-2">
                <span className="text-xs font-semibold text-muted-foreground">
                    {reward.label || t('play.nextReward')}
                </span>
                <span className="text-xs text-muted-foreground" data-testid={`${testId}-remaining`}>
                    {t('play.pointsToGo', { count: reward.remaining })}
                </span>
            </div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800"
                role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
                <div className="play-bar h-full rounded-full bg-gradient-to-r from-emerald-400 to-emerald-600"
                    style={{ width: `${pct}%` }} data-testid={`${testId}-fill`} />
            </div>
            {sample ? (
                <p className="mt-1 text-[11px] text-muted-foreground" data-testid={`${testId}-sample-note`}>
                    {t('play.sampleNote')}
                </p>
            ) : null}
        </div>
    );
};

export default RewardProgress;
